<div class="landing-screen-container">
  <div class="content-wrapper">
    <img src="assets/images/chevron-logo.png" alt="Chevron" class="logo" />
    <h1 class="title">Wells P&A Lookback and Performance Insights</h1>
    <div class="button-container">
      <button type="button" (click)="openApp.emit()" 
              title="Open P&A Insights Agent" 
              aria-label="Open P&A Insights Agent"
              class="open-button">
        &#x2192;
      </button>
    </div>
  </div>
</div>
